import Vue from 'vue'
import Vuex from 'vuex'
import { dashboard } from '@/store/dashboard'
import { profiles } from '@/store/profile'
import { output } from '@/store/output'
import { settings } from '@/store/settings.js'
import { process } from '@/store/process'
import { input } from '@/store/input'
import { fileupload } from '@/store/fileupload'
import { reports } from '@/store/reports'
Vue.use(Vuex)
const releaseType = BUILDTYPE == 'PROD' ? 'prodv2' : 'betav1'
const releaseType1 = BUILDTYPE == 'PROD' ? 'prodv3' : 'betav1'

const store = new Vuex.Store({
    state: {
        baseUrl: `https://vdrm.mobiotics.com/${releaseType}`,
        baseUrl1: `https://vdrm.mobiotics.com/${releaseType1}`,
        importFiles: "",
        loginUrl: `https://vauth.mobiotics.com/${releaseType}/provider/v1`,
        uploadUrl: `https://vauth.mobiotics.com/${releaseType}/vauthimage/v1`,
        reportInterval: "",
        reportInitiateBy: "",
        inputTableData: "",
        patternString: "",
        initListpackage: "",
        auth: ""
    },
    getters: {
        getAuthToken: (state) => {
            return state.auth
        },
        getbaseUrl: (state) => {
            return state.baseUrl
        },
        getbaseUrl1: (state) => {
            return state.baseUrl1
        },        
        getImportFiles: (state) => {
            return state.importFiles
        },
        getuploadUrl: (state) => {
            return state.uploadUrl
        },
        getloginUrl: (state) => {
            return state.loginUrl
        },
        getReportData: (state) => {
            return state.reportData
        },
        getReportInterval: (state) => {
            return state.reportInterval
        },
        getReportInitiatedBy: (state) => {
            return state.reportInitiateBy
        },
        getInputTableData: (state) => {
            return state.inputTableData
        },
        getPatternString: (state) => {
            return state.patternString
        },
        getInitListPackage: (state) => {
            return state.initListpackage
        }
    },
    mutations: {
        setAuthToken: (state, data) => {
            state.auth = data
        },
        setImportFiles: (state, data) => {
            state.importFiles = data
        },
        getuploadUrl: (state) => {
            return state.uploadUrl
        },
        setReportData: (state, data) => {
            state.reportData = data
        },
        setReportInterval: (state, data) => {
            state.reportInterval = data
        },
        setReportInitiateBy: (state, data) => {
            state.reportInitiateBy = data
        },
        setInputTableData: (state, data) => {
            state.inputTableData = data
        },
        setPatternString: (state, data) => {
            state.patternString = data
        },
        setInitListPackage: (state, data) => {
            state.initListpackage = data
        }
    },
    modules: {
        dashboard,
        profiles,
        process,
        output,
        input,
        settings,
        fileupload,
        reports
    }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js